export enum NoteStatus {
  Todo = 1,
  InProgress = 2,
  Complete = 3
}

export interface NoteStore {
  id: number;
  code: string;
  description: string;
}

export interface NoteStaff {
  id: number;
  firstName?: string;
  lastName?: string;
  name?: string;
  actorType?: string;
}

export interface NoteSalesRep {
  id: number;
  name: string;
}

export interface NoteAppointment {
  id: number;
  start: number;
  end: number;
  note: any;
  slot: {
    id: number;
  };
  purchasableItem: {
    id: number;
    description: string;
  };
  modifier: any;
  store: NoteStore;
  statusType: number;
  updatedAt: number;
  updatedBy?: NoteStaff;
}

export interface BaseNote {
  id: number;
  type: 'APPOINTMENT' | 'CUSTOMER' | 'COMMENT';
  categoryId: number | null;
  createdAt: number;
  createdBy: NoteStaff;
  content: String;
  showComments?: boolean;
}

export interface NotificationNote {
  id: number;
  assignee: NoteStaff;
  contactedVia: string | null;
  createdAt: number;
  createdBy: NoteStaff;
  customer: {
    id: number;
    firstName: string;
    lastName: string;
    fullName?: string;
  };
  followupDate: string | null;
  followupTime: number | null;
  note: string;
  noteCategory: {
    id: number;
    name: string;
  };
  status: string;
  subStatus: string;
  updatedAt: number;
}

export interface StaffNote extends BaseNote {
  updatedAt: number;
  status: string;
  assignee: NoteStaff;
  actorType?: string;
  contactedVia: string;
  followupDate: string | null;
  followupTime: number | 0;
  comments?: StaffNoteComment[];
  isPinned?: boolean;
  pinLoading?: boolean;
  expanded?: boolean;
}

export interface StaffNoteComment {
  id: number;
  content: String;
  createdBy: NoteStaff;
  createdAt: number;
  store: NoteStore;
}

export interface AppointmentNote extends BaseNote {
  id: number;
  start: number;
  end: number;
  firstName: string;
  lastName: string;
  createdAt: number;
  appointment: NoteAppointment;
  service: {
    category: number;
    description: string;
    id: number;
  };
  store: {
    code: string;
    description: string;
  };
  isPinned: boolean;
  pinLoading: boolean;
  expanded: boolean;
  isCancelled: boolean;
  isConfirmed: boolean;
}

export interface NoteCategory {
  id: number;
  name: string;
}

export type CustomerNote = StaffNote | AppointmentNote;

export enum NOTE_ACTIONS {
  EXPAND_NOTE_VIEW = 'EXPAND_NOTE_VIEW',
  COLLAPSE_NOTE_VIEW = 'COLLAPSE_NOTE_VIEW',
  PIN_NOTE = 'PIN_NOTE',
  UNPIN_NOTE = 'UNPIN_NOTE',
  ADD_NOTE = 'ADD_NOTE',
  INSERT_NOTE = 'INSERT_NOTE',
  EDIT_NOTE = 'EDIT_NOTE',
  UPDATE_NOTE = 'UPDATE_NOTE',
  DELETE_NOTE = 'DELETE_NOTE',
  REMOVE_NOTE = 'REMOVE_NOTE',
  INSERT_COMMENT = 'INSERT_COMMENT',
  REMOVE_COMMENT = 'REMOVE_COMMENT',
  SHOW_COMMENTS = 'SHOW_COMMENTS',
  HIDE_COMMENTS = 'HIDE_COMMENTS',
  UPDATE_NOTE_APPOINTMENT = 'UPDATE_NOTE_APPOINTMENT'
}
